/** @file The bones of an IK chain ending at a bone: [end] for one bone, [parent, end] for two. */
import type { Doc, Id } from '@pose2d/format/types';

/** null when `end` is unknown or a two-bone chain has no parent bone (ik.create would refuse it anyway). */
export function ikChainBones(doc: Doc, end: Id, length: 1 | 2): [Id] | [Id, Id] | null {
  const bone = doc.bones[end];
  if (bone === undefined) return null;
  if (length === 1) return [end];
  return bone.parent === null ? null : [bone.parent, end];
}
